import { useState, useEffect, useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as _ from 'lodash';
import axios from 'axios';
import FireStoreParser from 'firestore-parser';
import { DataContext } from '../context/data-context';

export const useStandings = (type = 'total', seasonArg) => {
  const { endpointUrl, currentSeason } = useContext(DataContext);
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(
        `${endpointUrl}data-endpoint/standings/${type}?season=${
          seasonArg || currentSeason
        }`
      )
      .then((response) => {
        setData(FireStoreParser(response.data)?.fields);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
      });
  }, [endpointUrl, setData]);

  const standings =
    data && !loading
      ? Object.keys(data)
          .map((key) => data[key])
          .filter((i) => i?.name)
      : [];

  return [standings, loading, error];
};
